<div
    class="errMessage"
    style="text-align: center"
    *ngIf="displayMessage"
>
    Settings successfully saved.
</div>
<div class="settingsHolder">
    <form
        class="example-form"
        [formGroup]="settingsFormVG"
        *ngIf="gameCode == 'VG'"
    >
        <div
            class="left"
            *ngIf="settingsLoaded"
        >
            <h1>Bet settings</h1>

            <div>
                <mat-form-field
                    class="example-full-width"
                    appearance="fill"
                >
                    <mat-label>Currency</mat-label>
                    <input
                        matInput
                        readonly
                        value="EUR"
                    />
                </mat-form-field>
            </div>

            <div>
                <mat-form-field appearance="fill">
                    <mat-label>Profile</mat-label>
                    <mat-select
                        [disabled]="disabledInputs"
                        formControlName="profile"
                        [(value)]="profileVG"
                    >
                        <mat-option
                            [value]="profile.val"
                            *ngFor="let profile of profilesVG"
                            >{{ profile.name }}</mat-option
                        >
                    </mat-select>
                </mat-form-field>
            </div>

            <div>
                <mat-form-field appearance="fill">
                    <mat-label>Min per betslip</mat-label>
                    <input
                        type="number"
                        [readonly]="disabledInputs"
                        matInput
                        #minPayin
                        formControlName="minPayin"
                        value="minPayin"
                    />
                </mat-form-field>
            </div>

            <div>
                <mat-form-field appearance="fill">
                    <mat-label>Max per betslip/selection </mat-label>
                    <input
                        type="number"
                        [readonly]="disabledInputs"
                        matInput
                        #minPayin
                        formControlName="maxPayin"
                        value="maxPayin"
                    />
                </mat-form-field>
            </div>

            <div>
                <mat-form-field appearance="fill">
                    <mat-label> Max payout per betslip</mat-label>
                    <input
                        type="number"
                        [readonly]="disabledInputs"
                        matInput
                        formControlName="maxPayout"
                        value="maxPayout"
                    />
                </mat-form-field>
            </div>

            <h3>Bet Increments</h3>
            <div class="smallTable smallTableVg">
                <table
                    mat-table
                    [dataSource]="dataSourceBetIncrement"
                    class="mat-elevation-z8"
                >
                    <!--- Note that these columns can be defined in any order.
                  The actual rendered columns are set as a property on the row definition" -->

                    <!-- Position Column -->
                    <ng-container matColumnDef="num">
                        <th
                            mat-header-cell
                            *matHeaderCellDef
                        ></th>
                        <td
                            mat-cell
                            *matCellDef="let element"
                            style="border-bottom: 1px solid black"
                        >
                            {{ element.num }}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="value">
                        <th
                            mat-header-cell
                            *matHeaderCellDef
                        ></th>
                        <td
                            mat-cell
                            *matCellDef="let element"
                            style="
                                border-bottom: 1px solid black;
                                width: 30vw;
                                border-left: 1px solid black;
                            "
                        >
                            {{ element.value }}
                        </td>
                    </ng-container>

                    <tr
                        mat-header-row
                        *matHeaderRowDef="displayedColumnsBetInc"
                    ></tr>
                    <tr
                        mat-row
                        *matRowDef="let row; columns: displayedColumnsBetInc"
                    ></tr>
                </table>
            </div>
        </div>

        <div
            class="middle"
            *ngIf="gameCode == 'VG' && settingsLoaded"
        >
            <h1>Jackpot settings</h1>
            <div>
                <mat-form-field
                    class="example-full-width"
                    style="padding: 10px"
                >
                    <input
                        matInput
                        placeholder="Start amount"
                        #startAmountClr
                        [readonly]="disabledInputs"
                        formControlName="startAmount"
                        value="startAmount"
                    />
                </mat-form-field>

                <mat-form-field
                    class="example-full-width"
                    style="padding: 10px"
                >
                    <input
                        matInput
                        placeholder="% Increment rate"
                        readonly
                        formControlName="rndAddition"
                        value="rndAddition"
                    />
                </mat-form-field>
            </div>

            <h2>Trigger #1</h2>
            <div>
                <mat-form-field
                    class="example-full-width"
                    style="padding: 10px"
                >
                    <input
                        matInput
                        placeholder="Min Amount"
                        #startAmountClr
                        [readonly]="disabledInputs"
                        formControlName="minAmount"
                        value="minAmount"
                    />
                </mat-form-field>

                <mat-form-field
                    class="example-full-width"
                    style="padding: 10px"
                >
                    <input
                        matInput
                        placeholder="Max Amount"
                        [readonly]="disabledInputs"
                        formControlName="maxAmount"
                        value="maxAmount"
                    />
                </mat-form-field>
            </div>
            <h2>Trigger #2</h2>
            <div>
                <mat-form-field
                    class="example-full-width"
                    style="padding: 10px"
                >
                    <input
                        matInput
                        placeholder="Min tickets"
                        #startAmountClr
                        [readonly]="disabledInputs"
                        formControlName="rndMin"
                        value="rndMin"
                    />
                </mat-form-field>

                <mat-form-field
                    class="example-full-width"
                    style="padding: 10px"
                >
                    <input
                        matInput
                        placeholder="Max tickets"
                        [readonly]="disabledInputs"
                        formControlName="rndMax"
                        value="rndMax"
                    />
                </mat-form-field>
            </div>
        </div>
    </form>

    <form
        class="example-form"
        [formGroup]="settingsFormGK"
        *ngIf="gameCode == 'GK' || gameCode == 'EK'"
    >
        <div
            class="left"
            *ngIf="settingsLoaded"
        >
            <h1>Bet settings</h1>

            <div>
                <mat-form-field
                    class="example-full-width"
                    appearance="fill"
                >
                    <mat-label>Currency</mat-label>
                    <input
                        matInput
                        readonly
                        value="EUR"
                    />
                </mat-form-field>
            </div>

            <h3>Bet Increments</h3>
            <div class="smallTable smallTableVg">
                <table
                    mat-table
                    [dataSource]="dataSourceBetIncrement"
                    class="mat-elevation-z8"
                >
                    <!--- Note that these columns can be defined in any order.
                  The actual rendered columns are set as a property on the row definition" -->

                    <!-- Position Column -->
                    <ng-container matColumnDef="num">
                        <th
                            mat-header-cell
                            *matHeaderCellDef
                        ></th>
                        <td
                            mat-cell
                            *matCellDef="let element"
                            style="border-bottom: 1px solid black"
                        >
                            {{ element.num }}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="value">
                        <th
                            mat-header-cell
                            *matHeaderCellDef
                        ></th>
                        <td
                            mat-cell
                            *matCellDef="let element"
                            style="
                                border-bottom: 1px solid black;
                                width: 30vw;
                                border-left: 1px solid black;
                            "
                        >
                            {{ element.value }}
                        </td>
                    </ng-container>

                    <tr
                        mat-header-row
                        *matHeaderRowDef="displayedColumnsBetInc"
                    ></tr>
                    <tr
                        mat-row
                        *matRowDef="let row; columns: displayedColumnsBetInc"
                    ></tr>
                </table>
            </div>
        </div>
    </form>

    <form
        class="example-form"
        [formGroup]="settingsFormL6"
        *ngIf="gameCode == 'L6'"
    >
        <div class="left">
            <h1>Bet settings</h1>
            <div>
                <mat-form-field
                    class="example-full-width"
                    appearance="fill"
                >
                    <mat-label>Currency</mat-label>
                    <input
                        matInput
                        readonly
                        value="EUR"
                    />
                </mat-form-field>
            </div>

            <div>
                <mat-form-field appearance="fill">
                    <mat-label>Profile</mat-label>
                    <mat-select
                        [disabled]="disabledInputs"
                        formControlName="profile"
                        [(value)]="profileL6"
                    >
                        <mat-option
                            *ngFor="let profile of profilesL6"
                            [value]="profile.val"
                            selected
                            >{{ profile.name }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div *ngIf="gameCode == 'L6'">
                <div class="smallTable">
                    <table
                        mat-table
                        [dataSource]="dataSourceMin"
                        class="mat-elevation-z8"
                    >
                        <!--- Note that these columns can be defined in any order.
                  The actual rendered columns are set as a property on the row definition" -->

                        <!-- Position Column -->
                        <ng-container matColumnDef="selection">
                            <th
                                mat-header-cell
                                *matHeaderCellDef
                            >
                                Selection
                            </th>
                            <td
                                mat-cell
                                *matCellDef="let element"
                            >
                                {{ element.selection }}
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="min">
                            <th
                                mat-header-cell
                                *matHeaderCellDef
                            >
                                Min Payin
                            </th>
                            <td
                                mat-cell
                                *matCellDef="let element"
                            >
                                {{ element.min }}
                            </td>
                        </ng-container>

                        <tr
                            mat-header-row
                            *matHeaderRowDef="displayedColumnsMin"
                        ></tr>
                        <tr
                            mat-row
                            *matRowDef="let row; columns: displayedColumnsMin"
                        ></tr>
                    </table>
                </div>
            </div>
            <div>
                <mat-form-field appearance="fill">
                    <mat-label>Max per selection</mat-label>
                    <input
                        type="number"
                        [readonly]="disabledInputs"
                        matInput
                        formControlName="maxPayin"
                        value="maxPayin"
                    />
                </mat-form-field>
            </div>

            <div>
                <mat-form-field appearance="fill">
                    <mat-label> Max payout per betslip (per Rd) </mat-label>
                    <input
                        type="number"
                        [readonly]="disabledInputs"
                        matInput
                        formControlName="maxPayout"
                        value="maxPayout"
                    />
                </mat-form-field>
            </div>
        </div>
    </form>
</div>
<div class="bottomButtonsDiv">
    <button
        class="bottomButton"
        mat-raised-button
        color="basic"
        style="width: 25%"
        (click)="onEdit()"
    >
        Edit
    </button>
    <button
        class="bottomButton"
        mat-raised-button
        color="primary"
        style="width: 25%"
        (click)="onSubmit()"
        [disabled]="disabledInputs"
    >
        Save
    </button>
</div>
